export const template = [
  {
    label: "登録を受け付けました。〇月〇日 〇時までに見積を提示します。",
    value: "登録を受け付けました。〇月〇日 〇時までに見積を提示します。",
    
  },
  {
    label: "データによる見積中です。〇月〇日〇時までに見積をお出しします",
    value: "データによる見積中です。〇月〇日〇時までに見積をお出しします",
  },
  {
    label: "現地で調査中です。〇月〇日〇時までに見積をお出しします",
    value: "現地で調査中です。〇月〇日〇時までに見積をお出しします",
  },
  {
    label: "見積書が出来ました！発注をお待ちしています！",
    value: "見積書が出来ました！発注をお待ちしています！",
  },
  {
    label: "現場から一番近い駐車場が空いていました！",
    value: "現場から一番近い駐車場が空いていました！",
  },
  {
    label: "一番近い駐車場ではありません。空き確認までに（具体的な時間）が必要です",
    value: "一番近い駐車場ではありません。空き確認までに（具体的な時間）が必要です",
  },
  {
    label: "この見積依頼はキャンセルとなりました",
    value: "この見積依頼はキャンセルとなりました",
  },
]